import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=6da5ae7e&scoped=true&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=6da5ae7e&prod&lang=css&"
import style1 from "./RoleEdit.vue?vue&type=style&index=1&id=6da5ae7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5ae7e",
  null
  
)

export default component.exports